import { diContainer } from "@/inversify.config";
import { ref } from "vue";
import {
  ICadastrarVoucherUsecase,
  cadastrarVoucherUsecaseDI
} from "../ports/CadastrarVoucherUseCase";
import Result from "@/core/common/Result";

export type Form = {
  email: string;
  whats: string;
  termos: boolean;
};

type CadastrarParams = Pick<Form, "email" | "whats"> & {
  voucherId: string;
};

export default function useVoucherForm() {
  const isLoading = ref(false);
  const cadastrarVoucherUseCase = diContainer.get<ICadastrarVoucherUsecase>(
    cadastrarVoucherUsecaseDI
  );

  const handleForm = async (params: CadastrarParams) => {
    isLoading.value = true;

    const response = await cadastrarVoucherUseCase.cadastrar({
      email: params.email,
      telefone: params.whats,
      idVoucher: params.voucherId
    });

    if (response.isFailure) {
      isLoading.value = false;

      return Result.fail(response.error);
    }

    isLoading.value = false;
    Result.ok();
  };

  return {
    handleFormSubmit: handleForm,
    isLoadingForm: isLoading
  };
}
